import cartClub from './cartClub';
import checkout, { checkoutActions } from './checkout';
import clubOffer, { ClubOfferActions } from './clubOffer';
import crossSell, { crossSellActions } from './crossSell';
import filterSearch from './filterSearch';
import generics, { genericsActions } from './generics';
import hotelDetails from './hotelDetails';
import mapHotel from './mapHotel';
import results, { resultsActions } from './results';
import search, { searchActions } from './search';
import user, { userActions } from './user';
import userReservationsList, { userReservationsListActions } from './userReservationsList';

export {
  ClubOfferActions,
  checkoutActions,
  crossSellActions,
  genericsActions,
  resultsActions,
  searchActions,
  userActions,
  userReservationsListActions,
};

export default {
  cartClub,
  clubOffer,
  crossSell,
  checkout,
  filterSearch,
  generics,
  hotelDetails,
  mapHotel,
  results,
  search,
  user,
  userReservationsList,
};
